import { takeEvery, call } from 'redux-saga/effects';
import service from '../../services/ocularis/ocularisService';

function* cancelAllRequests() {
    yield call(() => service.cancelAllRequests());
}

export default function*(){
    yield takeEvery('cancelAllRequests', cancelAllRequests)
}

